module.exports = __webpack_public_path__ + "static/frigemo2-14ef7a2b9ab00126afeff0be7bce41b1.png";